import { Sheet, Button, Typography, Box, IconButton, Modal, ModalOverflow, ModalDialog, ModalClose, Stack, Divider } from '@mui/joy';
import CloseIcon from '@mui/icons-material/Close';
import { useContext, useState } from 'react';
import { LayoutContext } from './context';
import { motion, AnimatePresence } from "framer-motion";



export default function PWAInstallBanner() {
    const { pwaStatus, checkNotificationStatus, subscribeUserToPush, getPlatform, modalNotification, setModalNotification, tokenEmployee } = useContext(LayoutContext);
    const [ dismissed, setDismissed ] = useState(false);
    

    const handleInstall = () => {
        if (pwaStatus?.platform === 'ios') {
            // Для iOS показываем инструкции
            alert('Для установки:\n1. Нажмите кнопку "Поделиться" (внизу Safari)\n2. Выберите "На экран "Домой"\n3. Откройте приложение с домашнего экрана');
        } if (getPlatform() === 'android') {
            // Для Android/Desktop - показываем событие установки
            const installEvent = new Event('showInstallPrompt');
            window.dispatchEvent(installEvent);
        }
    };
    
    const handleEnableNotifications = async () => {
        if (pwaStatus?.isInstalled) {
            await subscribeUserToPush();
        } else {
            alert('Сначала установите приложение');
        }
    };

    const notificationStatus = checkNotificationStatus?.();
    const [ openOffNotif, setOpenOffNotif ] = useState(
        typeof Notification !== 'undefined' && notificationStatus?.permission === 'denied'
    );

    if (dismissed || !pwaStatus?.showInstallPrompt) {
        return null;
    }

    if (openOffNotif) {
        return (
            <Sheet
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 9998,
                    p: 1,
                    backgroundColor: 'warning.soft',
                    textAlign: 'center',
                    ml: {
                        xs: 0, md: "273px"
                    },
                    borderTop: '1px solid #c7c7c7'
                }}
            >
                <Stack direction={'row'} sx={{ justifyContent: 'center' }}>
                    <Typography level="body-sm">
                        Уведомления отключены. Чтобы включить:{' '}
                        <Button
                            size="sm"
                            variant="plain"
                            onClick={() => {
                                // Показываем инструкцию
                                alert('1. Нажмите на иконку 🔒 слева от адресной строки\n2. Выберите "Настройки сайта"\n3. Найдите "Уведомления" и измените на "Разрешить"');
                            }}
                        >
                            Инструкция по включению
                        </Button>
                    </Typography>
                    <IconButton
                        size="sm"
                        variant="plain"
                        onClick={() => setOpenOffNotif(false)}
                        sx={{ height: 'fit-content' }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </Sheet>
        );
    }
    
    return (
        <>
            {tokenEmployee && checkNotificationStatus()?.permission !== 'granted' && (
                <Box>
                    { ['ios', 'android']?.includes(getPlatform()) ?
                    <Sheet
                        sx={{
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            zIndex: 9998,
                            px: 2,
                            py: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            boxShadow: 'lg',
                            borderTop: '1px solid',
                            borderColor: 'divider',
                            backgroundColor: 'background.surface',
                        }}
                    >
                        <Stack spacing={1} direction={'column'}>
                            <Stack spacing={0} direction={'row'} justifyContent={'center'} alignItems={'center'}>
                                <Typography level="body-sm" fontWeight="bold" sx={{ lineHeight: 1.1 }}>
                                    {pwaStatus.platform === 'ios' 
                                        ? 'Установите приложение для уведомлений'
                                        : 'Установите приложение для лучшего опыта'}
                                </Typography>
                                <IconButton
                                    size="sm"
                                    variant="plain"
                                    onClick={() => setDismissed(true)}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Stack>

                            <Stack direction={'row'} spacing={1}>
                                <Typography level="body-xs" color="neutral" sx={{ color: "neutral.400", lineHeight: 1.1 }}>
                                    {pwaStatus.platform === 'ios'
                                        ? 'Добавьте на домашний экран для работы уведомлений'
                                        : 'Получайте push-уведомления и работайте офлайн'}
                                </Typography>

                                {pwaStatus.isInstalled ? (
                                    <Button
                                        size="sm"
                                        onClick={handleEnableNotifications}
                                    >
                                        Включить уведомления
                                    </Button>
                                ) : (
                                    <Button
                                        size="sm"
                                        onClick={handleInstall}
                                    >
                                        Установить
                                    </Button>
                                )}
                            </Stack>
                        </Stack>
                    </Sheet>
                    :
                    <AnimatePresence>
                        {
                            modalNotification.open && (
                                <Modal
                                    sx={{ zIndex: 10015 }}
                                    open={modalNotification.open}
                                    onClose={() => setModalNotification({ open: false, type: 'default' })}
                                    slotProps={{
                                        backdrop: {
                                            component: motion.div,
                                            initial: { opacity: 0, backdropFilter: 'blur(0px)' },
                                            animate: { opacity: 1, backdropFilter: 'blur(8px)' },
                                            exit: { opacity: 0, backdropFilter: 'blur(0px)' },
                                            transition: { duration: 0.3, ease: "easeInOut" },
                                        }
                                    }}
                                >
                                    <ModalOverflow sx={{ height: 'auto' }}>
                                        <ModalDialog
                                            size="lg"
                                            component={motion.div}
                                            initial={{ opacity: 0, y: -10, scale: 0.98 }}
                                            animate={{ opacity: 1, y: 0, scale: 1 }}
                                            exit={{ opacity: 0, y: 10, scale: 0.98 }}
                                            transition={{ duration: 0.2, ease: "easeInOut" }}
                                            sx={(theme) => ({
                                                [theme.breakpoints.up("xl")]: {
                                                    width: '650px',
                                                    mx: 0,
                                                },
                                                [theme.breakpoints.down("xl")]: {
                                                    width: '550px',
                                                    mx: 0,
                                                },
                                                [theme.breakpoints.down("lg")]: {
                                                    width: '550px',
                                                    mx: 0,
                                                },
                                                [theme.breakpoints.down("md")]: {
                                                    width: '450px',
                                                    mx: 0,
                                                },
                                                [theme.breakpoints.down("sm")]: {
                                                    width: '95%',
                                                    p: 3,
                                                },
                                                width: '100%'
                                            })}
                                        >
                                            <ModalClose/>

                                            <Typography sx={{ textAlign: 'center', mb: 0 }} level="h3">
                                                PUSH-Уведомления
                                            </Typography>
                                            
                                            { modalNotification.type == 'new_activate' ?
                                                <Stack spacing={2}>
                                                    <Sheet color='neutral' variant='soft' sx={{ borderRadius: 'xl', p: 2 }}>
                                                        <Typography level="body-sm" color="primary" fontWeight="bold" sx={{ lineHeight: 1.2, mb: 1 }}>
                                                            Повторно подключить уведомления
                                                        </Typography>
                                                        <Typography level="body-xs" color="neutral" sx={{ lineHeight: 1.2 }}>
                                                            Ранее вы отключили уведомления. Необходимо активировать повторно нажав на настройки данной страницы, в строке ссылки
                                                        </Typography>
                                                    </Sheet>
                                                    
                                                    <img src='./screen_notif_on.jpg'/>
                                                </Stack>
                                            :
                                                <Stack spacing={2}>
                                                    <Sheet color='neutral' variant='soft' sx={{ borderRadius: 'xl', p: 2 }}>
                                                        <Typography level="body-sm" color="primary" fontWeight="bold" sx={{ lineHeight: 1.2, mb: 1 }}>
                                                            Сайт запрашивает доступ к уведомлениям
                                                        </Typography>
                                                        <Typography level="body-xs" color="neutral" sx={{ lineHeight: 1.2 }}>
                                                            Это разрешение дает возможность сайту отправлять уведомления, даже если вы закрыли его.
                                                        </Typography>
                                                    </Sheet>
                                                    
                                                    <img src='./screen_notif.jpg'/>

                                                    <Divider/>

                                                    <Sheet color='neutral' variant='soft' sx={{ borderRadius: 'xl', p: 2 }}>
                                                        <Typography level="body-xs" color="neutral" sx={{ lineHeight: 1.2 }}>
                                                            При необходимости, в дальнейшем можно будет отключить оповещения
                                                        </Typography>
                                                    </Sheet>
                                                </Stack>
                                            }
                                        </ModalDialog>
                                    </ModalOverflow>
                                </Modal>
                            )
                        }
                    </AnimatePresence>
                }
                </Box>
            )}
        </>
    );
}